export const environment = {
  production: true,
  apiBase: 'https://noisyradio.wahl.website',
  siteName: 'Noisy Radio',
  companyName: 'Noisy Radio',
  businessAddress: '',
  supportEmail: 'noisythangs@gmail.com',
  supportPhone: '',
  ageGateEnabled: false,
  coppaMode: false,
  privacyEffectiveDate: 'January 1, 2026',
  termsEffectiveDate: 'January 1, 2026',
  cookieEffectiveDate: 'January 1, 2026',
  dmcaAgentName: '',
  dmcaAgentEmail: '',
  dmcaAgentAddress: '',
  analyticsProvider: '',
};
